import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import kaiveLogo from '@/assets/logo/kaive-logo-dark.png';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title, subtitle }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f6fa',
        backgroundImage: 'linear-gradient(135deg, #f8f6fa 0%, #ece6f0 100%)',
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box
            component="img"
            src={kaiveLogo}
            alt="Kaive Admin"
            sx={{ height: 200, mt: -5, mb: -3 }}
          />
          {subtitle && (
            <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 500 }}>
              {subtitle}
            </Typography>
          )}
        </Box>

        <Paper
          elevation={3}
          sx={{
            padding: { xs: 3, sm: 4, md: 5 },
            borderRadius: 1,
            backgroundColor: 'background.paper',
            borderLeft: '8px solid',
            borderLeftColor: 'primary.main',
          }}
        >
          {title && (
            <Typography
              variant="h5"
              component="h1"
              sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}
            >
              {title}
            </Typography>
          )}
          {children}
        </Paper>

        <Typography
          variant="body2"
          sx={{ mt: 3, textAlign: 'center', color: 'text.secondary' }}
        >
          © {new Date().getFullYear()} Kaive. Todos os direitos reservados.
        </Typography>
      </Container>
    </Box>
  );
};
